// find features based upon some parameters.
// might just be a function, or possibly a component
// matches categories in order against any in out features data

const arraysIntersect = (array1, array2) => {
    for (let i = 0, len = array1.length; i < len; i++) {
        if (array2.includes(array1[i])) {
            return true;
        }
    }
    return false;
};

/**
 * Gets all features to a subscriber that has requested them
 * if categoriesRequested is passed and feature has categories property, those are checked
 * if featuresRequired is passed, featureName has to be in it
 * @param {Object} featureData
 * @param {Array} categoriesRequested
 * @param {Array|null} featuresRequired
 *
 * @returns {Object} { featureName: FeatureValueSelected }
 */
const getFeatures = ({ featureSelection = {} } = {}, categoriesRequested = [], featuresRequired = null) =>
    Object.keys(featureSelection).reduce((acc, featureName) => {
        const featureArray = featureSelection[featureName];

        // if no features were required it should match, otherwise check featureName presence in required features
        if (featuresRequired === null || featuresRequired?.includes(featureName)) {
            const { feature: featureSelected } =
                featureArray.find((feature) => {
                    if (!feature?.categories) return true;
                    const excludeCategory = feature?.exclude && arraysIntersect(feature.exclude, categoriesRequested);
                    // if has no categories property, means it should match if not already included.
                    if (arraysIntersect(feature.categories, categoriesRequested) && !excludeCategory) {
                        return true;
                    }
                }) || {};

            return { ...acc, [featureName]: featureSelected };
        }

        return acc;
    }, {});

export default getFeatures;
